import {Injectable} from '@angular/core';
import {AbstractFindOneByIdService} from '../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {AccountingAccountModel} from '../entity/accountingAccount.model';
import {AccountingAccountRepository} from '../../impl/service/ngrx/accountingAccount.repository';
import {AccountingAccountDataServiceAdapter} from '../../impl/service/ngrx/accountingAccountDataService.adapter';

@Injectable()
export class AccountingAccountFindOneByAccountIdService extends AbstractFindOneByIdService<AccountingAccountModel, AccountingAccountModel>{
    constructor(repository: AccountingAccountRepository, dataServiceAdapter: AccountingAccountDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
